const styles = {
  dialogPaper: {
    borderRadius: "16px",
    overflow: "hidden",
    maxWidth: 500,
    maxHeight: "90vh",
    width: "100%",
    background:
      "linear-gradient(135deg, #ffffff 0%, #f0fdf4 50%, #ecfdf5 100%)",
    border: "4px solid #014339",
    display: "flex",
    flexDirection: "column",
  },

  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    color: "#6B7280",
    zIndex: 10,
    "&:hover": { backgroundColor: "rgba(255,255,255,0.8)" },
  },

  sparkleTopRight: {
    position: "absolute",
    top: 40,
    right: 40,
    fontSize: 32,
    color: "#F7EE6F",
    pointerEvents: "none",
    animation: "spinScale 3s linear infinite",
    "@keyframes spinScale": {
      "0%": { transform: "scale(1) rotate(0deg)" },
      "50%": { transform: "scale(1.2) rotate(180deg)" },
      "100%": { transform: "scale(1) rotate(360deg)" },
    },
  },

  sparkleBottomLeft: {
    position: "absolute",
    bottom: 80,
    left: 40,
    fontSize: 24,
    color: "#B1B3F8",
    pointerEvents: "none",
    animation: "spinScaleReverse 3s linear infinite",
    "@keyframes spinScaleReverse": {
      "0%": { transform: "scale(1) rotate(360deg)" },
      "50%": { transform: "scale(1.2) rotate(180deg)" },
      "100%": { transform: "scale(1) rotate(0deg)" },
    },
  },

  content: {
    position: "relative",
    px: 3,
    py: 3,
    overflowY: "auto",
    flex: 1,
  },

  trophyWrapper: {
    display: "flex",
    justifyContent: "center",
    mb: 2,
    animation:
      "bounceIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s both",
    "@keyframes bounceIn": {
      "0%": { transform: "scale(0) rotate(-180deg)", opacity: 0 },
      "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
    },
  },

  trophyGlow: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    backgroundColor: "#F7EE6F",
    filter: "blur(16px)",
    opacity: 0.5,
  },

  trophyCircle: {
    position: "relative",
    background: "linear-gradient(135deg, #F7EE6F 0%, #EAB308 100%)",
    borderRadius: "50%",
    p: 2.5,
    border: "4px solid white",
    boxShadow: "0 8px 32px rgba(247, 238, 111, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  trophyIcon: {
    fontSize: 40,
    color: "#014339",
  },

  titleSection: {
    textAlign: "center",
    mb: 2,
    animation: "fadeSlideUp 0.4s ease 0.3s both",
    "@keyframes fadeSlideUp": {
      "0%": { opacity: 0, transform: "translateY(20px)" },
      "100%": { opacity: 1, transform: "translateY(0)" },
    },
  },

  title: {
    fontSize: "1.5rem",
    fontWeight: 800,
    color: "#014339",
    mb: 1,
  },

  subtitle: {
    fontSize: "0.95rem",
    color: "#6B7280",
  },

  benefitsSection: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 2,
    animation: "fadeSlideUp 0.4s ease 0.4s both",
  },

  benefitCard: (borderColor: string) => ({
    backgroundColor: "white",
    borderRadius: "12px",
    p: 2,
    border: `2px solid ${borderColor}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  }),

  benefitIconBox: (bgColor: string) => ({
    backgroundColor: bgColor,
    borderRadius: "8px",
    p: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),

  benefitIcon: (color: string) => ({
    fontSize: 24,
    color,
  }),

  benefitTitle: {
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#111827",
  },

  benefitDescription: {
    fontSize: "0.8rem",
    color: "#6B7280",
  },

  statsBox: {
    background: "linear-gradient(135deg, #014339 0%, #065f46 100%)",
    borderRadius: "12px",
    p: 2,
    mb: 2,
    textAlign: "center",
    color: "white",
    animation: "fadeSlideUp 0.4s ease 0.5s both",
  },

  statsTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    mb: 0.5,
    color: "white",
  },

  statsSubtitle: {
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.85)",
  },

  ctaSection: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    animation: "fadeSlideUp 0.4s ease 0.6s both",
  },

  primaryBtn: {
    backgroundColor: "#014339",
    color: "white",
    py: 1.75,
    fontSize: "1rem",
    fontWeight: 700,
    borderRadius: "10px",
    boxShadow: "0 4px 16px rgba(1, 67, 57, 0.35)",
    "&:hover": { backgroundColor: "rgba(1, 67, 57, 0.9)" },
    textTransform: "none",
  },

  dividerRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  },

  dividerLine: {
    flex: 1,
    height: "1px",
    backgroundColor: "#E5E7EB",
  },

  dividerText: {
    fontSize: "0.7rem",
    color: "#9CA3AF",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },

  secondaryBtn: {
    border: "2px solid #B1B3F8",
    color: "#014339",
    py: 1.5,
    fontSize: "0.9rem",
    fontWeight: 600,
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "rgba(177, 179, 248, 0.1)",
      border: "2px solid #B1B3F8",
    },
    textTransform: "none",
  },

  secondaryBtnHint: {
    fontSize: "0.75rem",
    color: "#9CA3AF",
    textAlign: "center",
    mt: 0.5,
  },

  encouragement: {
    textAlign: "center",
    fontSize: "0.85rem",
    color: "#6B7280",
    mt: 2,
    animation: "fadeSlideUp 0.4s ease 0.7s both",
  },

  confettiParticle: (
    x: number,
    duration: number,
    color: string,
    size: number,
    delay: number,
  ) => ({
    position: "absolute",
    top: -10,
    left: `${x}%`,
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: color,
    pointerEvents: "none",
    animation: `confettiFall ${duration}s linear ${delay}s both`,
    "@keyframes confettiFall": {
      "0%": { transform: "translateY(0) rotate(0deg)", opacity: 1 },
      "100%": { transform: "translateY(100vh) rotate(360deg)", opacity: 0 },
    },
  }),
};

export default styles;
